export const GET_MODIFIER_GROUP = 'providers/menuMaker/ModifierGroupDetails/GET_MODIFIER_GROUP';
export const EDIT_MODIFIER_GROUP = 'providers/menuMaker/ModifierGroupDetails/EDIT_MODIFIER_GROUP';
